import db from "@/plugins/dexie";
import { USER_STORAGE  } from '@/constants/STORAGE'
import apirecebimentoweb from '@/services/api-recebimentoweb';
import moment from "moment-timezone";

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}

export default async function $_enviaSecagem() {
  const token = JSON.parse(sessionStorage.getItem('auth:token'));
  let secagem = await db.secagem.toArray();
  secagem = secagem.filter(a => !a.secidnuvem || !a.secdatanuvem);
  const idusuario = await getSessionStorage(USER_STORAGE.useidusuario);
  secagem.forEach((item) => {
          if ((item.secidnuvem)) {
              console.log('put - ', item);
              const payload = {

                id: item.secidnuvem,
                secdatatermino: item.secdatatermino,
                sectempooperacao: item.sectempooperacao,
                secstatus: item.secstatus,
                secidusuario: idusuario,
                secidlocalmovimentacaoestoque: item.secidlocalmovimentacaoestoque,
                secsecador: item.secsecador,
                secumidadefinal: item.secumidadefinal
                //secdatainicio: item.secdatainicio,
                //sectipooperacao: item.sectipooperacao,
                //secidsecador: item.secidsecador,
                //secumidade: item.secumidade,
                //sectemperaturaar: item.sectemperaturaar,
                //secumidadear: item.secumidadear,
                //secpesoentrada: item.secpesoentrada
              }
              apirecebimentoweb.put(`/secagem/${item.secidnuvem}`, payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  const alteracao = (moment.utc(res.data.secdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.secagem.update(item.id, {
                      secdataalteracao: res.data.absdataalteracao,
                      secdatanuvem: alteracao,
                      secdatatermino: res.data.secdatatermino,
                      secidlocalmovimentacaoestoque: res.data.secidlocalmovimentacaoestoque,
                  });
              });    
          } else {
              console.log('post - ', item);

              const totalFormatado = new Intl.NumberFormat("pt-BR", {
                minimumFractionDigits: 4,
                maximumFractionDigits: 4,
              }).format((`${item.secpesoentrada}`).replace('.', ''));

              const payload = {
                secdatainicio: item.secdatainicio,
                secdatatermino: item.secdatatermino,
                sectempooperacao: item.sectempooperacao,
                sectipooperacao: item.sectipooperacao,
                secidusuario: idusuario,
                secidlocalmovimentacaoestoque: item.secidlocalmovimentacaoestoque,
                secsecador: item.secsecador,
                secidsecador: item.secidsecador,
                secumidade: item.secumidade,
                secumidadefinal: item.secumidadefinal,
                sectemperaturaar: item.sectemperaturaar,
                secumidadear: item.secumidadear,
                secpesoentrada: totalFormatado.replace('.', '').replace(',', '.')
              }
              apirecebimentoweb.post('/secagem', payload, {
                  headers: {
                      Authorization: `Bearer ${token.token}`
                  }
              }).then((res) => {
                  console.log(res, 'res');
                  const alteracao = (moment.utc(res.data.secdataalteracao).subtract(3, 'hours').format('YYYY-MM-DDTHH:mm:ss'))
                  db.secagem.update(item.id, {
                      secidusuario: res.data.secidusuario,
                      secidnuvem: res.data.id,
                      secdataalteracao: res.data.absdataalteracao,
                      secdatanuvem: alteracao,
                  });
                  db.operacao.where({opedatainicio: item.secdatainicio}).first().then((op) => {
                    db.operacao.update(op.id, {
                      opeidnuvem: res.data.id,
                    })
                  });
              });
          }
  }); 
}